module.exports = __webpack_public_path__ + "media/images/fastweb30-nav-51c11d29.svg";